<template>
  <DashboardTemplate>
    <div v-loading="loading">
      <div class="pd-b-3">
        <div class="flex-display ai-center js-between">
          <div class="flex-display ai-center">
            <div>
              <span class="circle-adjunct color-bg-secondary">
                <i class="fas fa-comment-alt"></i>
              </span>
            </div>
            <h3 class="text-font-24 pd-l-4 mg-y-less text-left">
              กระดานถาม - ตอบระหว่างเรียน (Discussion Forum)
            </h3>
          </div>
          <div v-if="discussion && discussion.durationTime">
            <span
              class="text-font-14"
              :class="
                new Date().setHours(0,0,0,0) <= new Date(discussion.durationTime.close).getTime()
                  ? 'color-gray'
                  : 'color-danger'
              ">
              <i class="fas fa-exclamation-triangle"></i>
                <span v-if="new Date().setHours(0,0,0,0) <= new Date(discussion.durationTime.close).getTime()"> กำหนดสิ้นสุดการตอบคำถามวันที่ {{ discussion.durationTime.close | dateTh }}</span>
                <span v-else> หมดเวลาตอบคำถามแล้ว</span>
            
            </span>
           </div>
        </div>
      </div>
      <div>
        <DiscussionForumCard
          v-if="discussion"
          :title="discussion.title"
          :description="discussion.description"
          :createBy="discussion.createdBy"
          :createName="discussion.name"
          :createProfileImg="discussion.profileImg"
          :createAt="new Date(discussion.createdAt)"
        />
      </div>
      <div v-if="discussion && discussion.durationTime && Date.now() >= new Date(discussion.durationTime.open).getTime() && 
         new Date().setHours(0,0,0,0) <= new Date(discussion.durationTime.close).getTime()" class="pd-x-1 pd-t-3 box-forum-comment">
        <DiscussionForumComment
          :discussionId="discussionId"
          :courseId="courseId"
          @fetchDiscussionId="fetchDiscussionId"
        />
      </div>
      <div class="pd-x-1 pd-t-4 pd-b-3 custom-box-comment">
        <div
          v-if="discussion"
          class="border-l border-color-secondary border-big-bold"
        >
          <div v-for="(item, index) in replyList" :key="index">
            <DiscussionForumCard
              type="comment"
              :replyId="item._id"
              :discussionId="discussionId"
              :title="item.title"
              :description="item.text"
              :createBy="item.createdBy"
              :createName="item.name"
              :createProfileImg="item.profileImg"
              :createAt="new Date(item.createdAt)"
              @fetchDiscussionId="fetchDiscussionId"
            />
          </div>
        </div>
      </div>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import DiscussionForumCard from "@/components/discussionForum/DiscussionForumCard";
import DiscussionForumComment from "@/components/discussionForum/DiscussionForumComment";
import Avatar from "vue-avatar";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    DiscussionForumCard,
    DiscussionForumComment,
    Avatar,
  },
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    replyList(){
      if (!this.discussion) {
        return []
      }
      
      return this.discussion.reply.sort((a,b)=>{
        if (a.createdAt > b.createdAt) { return -1}
        return 0
      })
    }
  },  
  data() {
    return {
      form: {
        comment: "",
      },
      rules: {
        comment: [
          {
            required: true,
            message: "กรุณากรอกความคิดเห็น",
            trigger: "blur",
          },
        ],
      },
      discussion: null,
      loading: true,
      discussionId: "",
      courseId: "",
    };
  },
  mounted() {
    this.setParams();
    this.fetchDiscussionId();
    this.viewDiscussion();
  },
  methods: {
    setParams() {
      if (this.routeParams != null) {
        this.discussionId = this.routeParams.discussionId;
        this.courseId = this.routeParams.courseId;
      }
    },
    fetchDiscussionId() {
      this.loading = true;
      let obj = {
        _id: this.discussionId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/discussion`, obj)
        .then((res) => {
          if (res.data.success) {
            this.discussion = res.data.obj;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchDiscussionId error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    viewDiscussion() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`view/${this.discussionId}`).then((res) => {});
    },
  },
};
</script>

<style scoped></style>
